import AnswerPreview from './answer_preview';
export default AnswerPreview;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/answer_panel/preview/index.js